'use strict';
var parent = require('../../es/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/define-property.js
// module id = 774
// module chunks = 13